/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${(props) => props.theme.colors.background.primary};
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.4rem;
`;

export const HeaderTextGroup = styled.div``;

export const PageTitle = styled.h1.attrs({
  className: 'section-heading',
})`
  margin: 0.8rem;
`;

export const PageSubtitle = styled.p.attrs({
  className: 'section-sub-heading',
})`
  margin: 0.8rem;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;

  &:hover {
    background: ${(props) => props.theme.colors.brand.secondary};
  }
`;

export const Card = styled.div``;

export const CardHeader = styled.div`
  padding: 2.4rem 2.4rem 1.6rem;
`;

export const Tag = styled.div.attrs({
  className: 'body-small',
})`
  display: flex;
  align-items: center;
  background: ${(props) => props.theme.colors.brand.secondary};
  color: ${(props) => props.theme.colors.brand.primary};
  padding: 0.8rem 1.6rem;
  border-radius: 9999px;
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  margin-right: 1.2rem;
`;

export const TagGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 1.2rem;
`;

export const CardContent = styled.div`
  padding: 0 2.4rem 2.4rem;
`;

export const InputSection = styled.div`
  margin: 2.4rem 0;
`;

export const InputLabel = styled.label.attrs({
  className: 'label',
})`
  display: block;
  margin-bottom: 0.8rem;
  color: ${(props) => props.theme.colors.text.primary};
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input.attrs({
  className: 'body-medium',
})`
  width: 100%;
  padding: 0.8rem;
  padding-right: 4rem;
  border: 1px solid ${(props) => props.theme.colors.border.default};
  border-radius: 8px;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.brand.primary};
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.brand.secondary};
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.text.disabled};
  }
`;

export const InputHelpText = styled.p.attrs({
  className: 'body-small',
})`
  margin-top: 0.8rem;
  color: ${(props) => props.theme.colors.text.secondary};
`;

export const Separator = styled.hr`
  border: 0;
  height: 1px;
  background: ${(props) => props.theme.colors.border.default};
  margin: 2.4rem 0;
`;

export const BenefitsSection = styled.div`
  margin-bottom: 2rem;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.border.default};
`;

export const BenefitsTitle = styled.h3.attrs({
  className: 'section-heading',
})`
  margin: 0;
  margin-bottom: 2rem;
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.6rem;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const BenefitCard = styled.div`
  padding: 1rem;
  border-radius: 0.8rem;
  background: ${(props) => props.theme.colors.background.secondary};
`;

export const BenefitIcon = styled.div`
  margin-bottom: 1rem;
`;

export const BenefitTitle = styled.h4.attrs({
  className: 'body-small',
})`
  margin: 0 0 0.8rem 0;
  color: ${(props) => props.theme.colors.text.primary};
  font-weight: ${(props) => props.theme.typography.fontWeight.semiBold};
`;

export const BenefitDescription = styled.p.attrs({
  className: 'body-small',
})`
  margin: 0;
  color: ${(props) => props.theme.colors.text.secondary};
`;

export const CardFooter = styled.div`
  padding: 0 2.4rem 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    flex-direction: row;
    gap: 1.6rem;
  }
`;

export const SecondaryButton = styled.button.attrs({
  className: 'button-title',
})`
  padding: 1.2rem 2.4rem;
  background: transparent;
  border: 1px solid ${(props) => props.theme.colors.brand.primary};
  color: ${(props) => props.theme.colors.brand.primary};
  border-radius: 0.8rem;
  cursor: pointer;
  width: 100%;
  order: 2;
  flex: 1;

  &:hover {
    background: ${(props) => props.theme.colors.brand.secondary};
  }

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    order: 1;
  }
`;

export const PrimaryButton = styled.button.attrs({
  className: 'button-title',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem 2.4rem;
  background: ${(props) => props.theme.colors.brand.primary};
  color: white;
  border: none;
  border-radius: 0.8rem;
  cursor: pointer;
  width: 100%;
  order: 1;
  flex: 1;

  &:hover {
    background: ${(props) => props.theme.colors.brand.tertiary};
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    order: 2;
  }
`;

export const ButtonIcon = styled.img`
  width: 1.6rem;
  height: 1.6rem;
  margin-left: 1.2rem;
`;

export const FooterNote = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2.4rem;
`;

export const FooterText = styled.p.attrs({
  className: 'body-small',
})`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.text.secondary};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.img`
  width: ${(props) => props.size || '1.6rem'};
  height: ${(props) => props.size || '1.6rem'};
  margin-right: ${(props) => props.marginRight || '0'};
`;

export const ValidIcon = styled.div`
  position: absolute;
  right: 1.6rem;
  top: 50%;
  transform: translateY(-50%);
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.background.primary};
`;
